module.exports = __webpack_public_path__ + "static/media/Home.f645f568.png";